<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="Gallery" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div style="display: flex; justify-content: space-between; gap: 8px; width: 100%;">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New</h7>
                            </button>
                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </div>
                    </div>

                    <div class="card-body">
                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="gallery_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(location)="data">
                                        <div style="max-width: 200px;">
                                            {{ data.item?.location?.name }}
                                        </div>
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img style="height: 80px; border-radius: 4px;" :src="host + row.item.image" alt="">
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteResearch(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editResearch(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Gallery Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Gallery" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Location</label>
                        <select class="form-control digits" v-model="item.location">
                            <option v-for="(loc, index) in location" :key="index" :value="loc">{{ loc.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Width (Max: 4)</label>
                        <input class="form-control" type="number" v-model="item.width" placeholder="Enter width" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="item.image" style="height: 80px; border-radius: 6px;" :src="item.image">
                        <input :class="item.image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadImage">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Gallery Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Gallery" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Location</label>
                        <select class="form-control digits" v-model="edit_item.location">
                            <option v-for="(loc, index) in location" :key="index" :value="loc">{{ loc.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Width (Max: 4)</label>
                        <input class="form-control" type="number" v-model="edit_item.width" placeholder="Enter width" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                        <input :class="edit_item.image ? 'ml-2' : 'ml-2'" type="file" accept="image/*" @change="uploadImage2">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this item?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    components: {
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'width',
                    label: 'Width (Out of 4)',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            item: {
                location: '',
                width: 1,
                image: null
            },

            edit_item: {
                id: '',
                width: null,
                location: '',
                image: null
            },

            delete_value: null,
            show_image: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            gallery_list: state => state.gallery.gallery,
            location: state => state.words.location,
            loading: state => state.gallery.galleryLoading,
            error: state => state.gallery.galleryError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("words/fetchLocation")
        this.$store.dispatch("gallery/fetchGallery").then(() => {
            this.items = this.gallery_list
            this.totalRows = this.gallery_list.length;
        });
    },

    methods: {
        uploadImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.item.image = e.target.result
            };
        },

        uploadImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_item.image = e.target.result
                this.show_image = e.target.result
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.item = {
                location: '',
                width: 1,
                image: null
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("gallery/addGallery", {
                item: this.item
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editResearch(detail) {
            this.edit_item = {
                id: detail.id || null,
                location: detail ?.location || null,
                width: detail.width || 1
            };
            this.show_image = this.host + detail.image || null
        },

        resetEditModal() {
            this.edit_item = {
                id: '',
                location: '',
                width: null,
                image: null
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("gallery/updateGallery", {
                id: this.edit_item.id,
                item: this.edit_item
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteResearch(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("gallery/deleteGallery", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
